import React from "react";
import { extractContextFromDescription, detectIntent, getIntroText } from "./intentUtils";


const DisplayMessage = ({ json, originalQuestion } ) => {
	console.log(json);
	console.log("DisplayMessage");

  const intent = detectIntent(originalQuestion);
  const introText = getIntroText(intent);

  return (
    <div>
      <p>{introText}</p>

      {json.data.Get.Articles.map((article, index) => (
        <div key={index}>
          {article.articleType === "car" ? (

            <>
              <p>{article.title}</p>
			{extractContextFromDescription(article.description, intent) && (
              <p style={{ fontStyle: "italic", color: "#ccc" }}>
                {extractContextFromDescription(article.description, intent)}
              </p>
            )}              
              <div style={{ float: "right" }}>
                <a style={{ color: "#fff" }} href={article.url}>informieren</a>
              </div>
              <br />
            </>
          ) : (
            <>
              <p>
                Auf der <b>{article.title}</b> in <b>{article.location}</b> stellen wir vom {article.fromDate} bis {article.toDate} folgende Autos aus:
              </p>
              <ul>
                {article.vehicles.map((vehicle, idx) => (
                  <li key={idx}>{vehicle}</li>
                ))}
              </ul>
            </>
          )}
          <hr />
        </div>
      ))}
    </div>
  );
};

export default DisplayMessage;
